import { render, staticRenderFns } from "./ExpenseDetailsTable.vue?vue&type=template&id=4557f118&scoped=true&"
import script from "./ExpenseDetailsTable.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDetailsTable.vue?vue&type=style&index=0&id=4557f118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557f118",
  null
  
)

export default component.exports